import { Link } from 'react-router-dom';
import { latestComics, hotComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function LatestUpdates() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
                  最新更新
                </h2>
                <p className="mt-1 text-sm text-foreground-500">
                  实时更新，精彩不停歇
                </p>
              </div>
              <Link
                to="/category?sort=latest"
                className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                更多
                <i className="ri-arrow-right-line text-xs" />
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 md:gap-5" data-product-shop="">
              {latestComics.slice(0, 6).map((comic) => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          </div>

          <div>
            <div className="mb-6">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
                热门排行
              </h2>
              <p className="mt-1 text-sm text-foreground-500">
                大家都在看的热门漫画
              </p>
            </div>
            <div className="bg-background-100 rounded-xl p-4 md:p-5">
              {hotComics.slice(0, 8).map((comic, index) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.slug}`}
                  className="flex items-center gap-3 py-3 border-b border-background-200 last:border-b-0 group cursor-pointer"
                >
                  <span className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                    index < 3
                      ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                      : 'bg-background-200 text-foreground-500'
                  }`}>
                    {index + 1}
                  </span>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                      {comic.title}
                    </h4>
                    <div className="flex items-center gap-2 mt-0.5">
                      <span className="text-xs text-foreground-400">{comic.category}</span>
                      <span className="text-xs text-foreground-300">·</span>
                      <span className="text-xs text-accent-500 flex items-center gap-0.5">
                        <i className="ri-star-fill text-[9px]" />{comic.rating}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}